import { useContext } from 'react';
import { ToastContext } from '~/components/Toast/src/Toast';

export const useToast = () => useContext(ToastContext);
